// Footer.js

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom" style={{backgroundColor:"black",color:"white"}}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="social-icon text-md-start text-center mb-3 mb-md-0">
                {
                  !localStorage.getItem("appkey") && (
                    <>
                      <h4 style={{ textDecoration: "underline",color:"white" }}>Explore</h4>
                      <p>
                        <span><Link to="/privacy-policy" target='_top' style={{color:"white"}}>Privacy Policy</Link></span><br />
                        <span><Link to="/terms" target='_top' style={{color:"white"}}>Terms & Conditions</Link></span><br />
                        <span><Link to="/refund-policy" target='_top' style={{color:"white"}}>Refund Policy</Link></span><br />
                        <span><Link to="/contact" target='_top' style={{color:"white"}}>Contact Us</Link></span><br />
                        <span><Link to="/about" target='_top' style={{color:"white"}}>About Us</Link></span><br />
                      </p>
                    </>
                  )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="social-icon-round icon-sm text-md-start text-center mb-3 mb-md-0">
                <ul>
                  <li> <Link to={'mailto:admin@growniverse.com'} target='_blank' style={{ color: '#9F9F9F', fontSize: '18px' }}><i className="fa fa-envelope"></i></Link></li>
                  <li><Link to={'https://www.instagram.com/growniverseofficial/'} target='_blank' style={{ color: '#C13584', fontSize: '18px' }}><i className="fab fa-instagram"></i></Link></li>
                  <li><Link to={'https://youtube.com/@growniverse?si=HipqeODMzh2ZDsLl'} style={{ color: '#FF0000', fontSize: '18px' }} ><i className="fab fa-youtube"></i></Link></li>
                  <li><Link to={'https://t.me/growniverse'} target='_blank' style={{ color: '#0088CC', fontSize: '18px' }}><i className="fab fa-telegram"></i></Link></li>
                  <li><Link to={'https://www.facebook.com/profile.php?id=61570584860719'} target='_blank' style={{ color: '#1877F2', fontSize: '18px' }}><i className="fab fa-facebook-f"></i></Link></li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="copyright text-md-end text-center">
                <p className="mb-0 small">© Copyright 2026 <Link to="#" style={{color:"white"}}>Growniverse</Link> All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
